module.exports = __webpack_public_path__ + "static/p4-7ffe2fb364d705f27ac39c3a365dd48a.jpg";